'use client'

import { EmptyBlock as EmptyBlockType } from '@/payload-types';
import { TypedLocale } from 'payload';
import React from 'react';

export const EmptyBlock: React.FC<EmptyBlockType & {
  id?: string,
  locale: TypedLocale
}> = ({
  locale, blockName, padding, lgPadding, mdPadding
}) => {
  // Convert padding values to numbers, defaulting to 0 if undefined
  const basePadding = Number(padding) || 0;
  const mdPaddingValue = Number(mdPadding) || basePadding;
  const lgPaddingValue = Number(lgPadding) || mdPaddingValue;

  return (
    <section id="emptyBlock" className="container">
      <style>{`
        #emptyBlock {
          padding-top: ${basePadding}rem;
          padding-bottom: ${basePadding}rem;
        }
        @media (min-width: 768px) {
          #emptyBlock {
            padding-top: ${mdPaddingValue}rem;
            padding-bottom: ${mdPaddingValue}rem;
          }
        }
        @media (min-width: 1024px) {
          #emptyBlock {
            padding-top: ${lgPaddingValue}rem;
            padding-bottom: ${lgPaddingValue}rem;
          }
        }
      `}</style>
    </section>
  );
};




export function getPaddingValue(value: string | number | undefined): string | undefined {
    if (typeof value === 'number') {
      return `${value}px`;
    }
    if (typeof value === 'string') {
      return value.includes('px') ? value : `${value}px`;
    }
    return undefined;
  }
